import {StyleSheet} from 'react-native';

import {indent} from '/constant/layout.constant';

export const styles = StyleSheet.create({
  taskListContainer: {
    paddingTop: indent,
  },
  loader: {
    marginTop: indent * 2,
  },
});
